import image from './image';

export default image;
